import Image from "next/image";
import React from "react";
type Props = {
  className?: string;
};

function LogoIcon({ className }: Props) {
  return (
    <div className={className}>
      <Image
        src="/images/logo/logo.svg"
        alt="Logo"
        width={40}
        height={40}
        className={className}
        priority
      />
    </div>
  );
}

export default LogoIcon;
